import React from 'react'
import PropTypes from 'prop-types'

import V1 from './template/v1/V1'
import { HeaderProvider } from './HeaderContext'

const Header = ({
  template = 'v1',
  lightMode = false,
  enableTracking = false,
  pageOrScreen = '',
  hasSubNav = false,
  isMinimal = false,
  ...rest
}) => {
  const providerProps = {
    lightMode,
    enableTracking,
    pageOrScreen,
    hasSubNav,
    isMinimal,
  }

  switch (template) {
    case 'v1':
      return (
        <HeaderProvider {...providerProps}>
          <V1 {...rest} />
        </HeaderProvider>
      )
    case 'v1_nowrap':
      return <V1 {...rest} />
    default:
      return (
        <HeaderProvider {...providerProps}>
          <V1 {...rest} />
        </HeaderProvider>
      )
  }
}

Header.propTypes = {
  template: PropTypes.string,
  lightMode: PropTypes.bool,
  enableTracking: PropTypes.bool,
  pageOrScreen: PropTypes.string,
  hasSubNav: PropTypes.bool,
}

export default Header
